import React, { useState } from 'react';
import AdminNav from './AdminNav';
import AdminSidebar from './AdminSidebar';
import './AdminLayout.css';

function AdminLayout({ 
  children, 
  user, 
  onLogout, 
  roleColor = '#667eea',
  dashboardTitle = 'Admin Center',
  menuItems = [],
  activeTab,
  onTabChange,
  apiBase
}) {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const handleMobileSidebarOpen = () => {
    setIsMobileSidebarOpen(true);
  };

  const handleMobileSidebarClose = () => {
    setIsMobileSidebarOpen(false);
  };

  const handleSidebarToggle = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    <div className="admin-layout">
      <AdminNav 
        user={user}
        onLogout={onLogout}
        roleColor={roleColor}
        dashboardTitle={dashboardTitle}
        onMenuToggle={handleMobileSidebarOpen}
        isCollapsed={isSidebarCollapsed}
        onToggleCollapse={handleSidebarToggle}
        apiBase={apiBase}
      />

      <div className="admin-body">
        <AdminSidebar 
          activeTab={activeTab}
          onTabChange={onTabChange}
          menuItems={menuItems}
          roleColor={roleColor}
          isMobileOpen={isMobileSidebarOpen}
          onMobileClose={handleMobileSidebarClose}
          isCollapsed={isSidebarCollapsed}
          onToggleCollapse={handleSidebarToggle}
        />

        <main className={`admin-main ${isSidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
          {children}
        </main>
      </div>
    </div>
  );
}

export default AdminLayout;
